import React from "react";

const PostedBy = ({ selectedPostedBy = [], handlePostedByPress }) => {
  const propertyPost = [
    { id: "1", name: "Owner" },
    { id: "2", name: "Builder" },
    { id: "3", name: "Dealer" },
  ];

  return (
    <div className="mainbarfiltercomponents">
      {propertyPost.map((posted, index) => {
        const isChecked = selectedPostedBy.some(
          (p) => p.toLowerCase() === posted.name.toLowerCase()
        );
        return (
          <div
            className="propertyboxes"
            key={index}
            onClick={() => handlePostedByPress && handlePostedByPress(posted.name)}
            style={{ cursor: "pointer" }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {}}
              style={{ cursor: "pointer" }}
            />
            <p className="propertytextpara" style={{ margin: 0, paddingLeft: "8px" }}>
              {posted.name}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default PostedBy;